import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=27412348"
import script from "./GenericModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports